import { FormControl, FormHelperText, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import MaterialInput from "../../../../../../components/MaterialInput";
import MaterialTypography from "../../../../../../components/MaterialTypography";
import MaterialBox from "../../../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialSelect from "../../../../../../components/MasterSelect";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useUserDetails } from "../../../../../../context/auth";
import MaterialDatePicker from "../../../../../../components/MaterialDatePicker";
const EmployeeInformation = ({
  employeeData,
  setEmployeeData,
  handleEmployeeDataChange,
  resources,
  reportManager,
  department,
  designation,
  shiftdata,
  probationOptions,
  togglePage,
  handleChange,
  roledata,
  typedata,
  attendanceId,
  Active,
  handleactive,
}) => {
  const [isFocused, setIsFocused] = useState(null);
  const { validation, validationMessages } = useUserDetails();
  console.log("reportManager:", reportManager);

  const today = new Date().toISOString().split("T")[0];

  console.log(employeeData, "emmppdata");

  console.log(togglePage, "to3223");

  const handlejoiningdate = (selectedDates) => {
    if (selectedDates.length > 0) {
      let val = selectedDates[0];
      let formattedDate = new Date(
        val.getTime() - val.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .split("T")[0]; // Ensures local timezone is used correctly
      console.log("Formatted Start Date:", formattedDate);

      // setHolidayData({
      //   ...holidayData,
      //   startDate: formattedDate,
      //   startDateStatus: "success",
      // });

      setEmployeeData((prev) => ({
        ...prev,
        joiningDate: formattedDate,
        joiningDateStatus: "success",
      }));
    }
  };

  const formatDate = (date) => {
  if (!date) return ""

  if (date.includes("-") && date.split("-")[0].length === 4) {
    return date
  }

  const [day, month, year] = date.split("-")
  return `${year}-${month}-${day}`
}

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Employee ID <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <Stack>
          <MaterialInput
            name="employeeId"
            value={employeeData.employeeId}
            // placeholder="Enter a employee id"
            onChange={handleEmployeeDataChange}
            error={employeeData.employeeIdStatus === "error" ? true : false}
            success={employeeData.employeeIdStatus === "success" ? true : false}
            disabled={togglePage.view === true ? true : false}
          />
          {/* {employeeData.employeeIdStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Employee id should be 3 to 20 characters long.
              </FormHelperText>
            </FormControl>
          )} */}
          {validationMessages.employeeId && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.employeeId}
            </label>
          )}
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Joining date <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="joiningDate"
          type="date"
          value={employeeData.joiningDate}
          onChange={handleEmployeeDataChange}
          error={employeeData.joiningDateStatus === "error" ? true : false}
          success={employeeData.joiningDateStatus === "success" ? true : false}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            max: new Date().toISOString().split("T")[0], // Today's date
            min: new Date(new Date().setMonth(new Date().getMonth() - 3))
              .toISOString()
              .split("T")[0], // 3 months before today
          }}
        />
        {/* <MaterialDatePicker
          name="joiningDate"
          options={{
            maxDate: new Date().toISOString().split("T")[0],
            minDate: new Date(new Date().setMonth(new Date().getMonth() - 3))
              .toISOString()
              .split("T")[0],
          }}
          onChange={handlejoiningdate}
           value={formatDate(employeeData.joiningDate)}
          error={employeeData.joiningDateStatus === "error" ? true : false}
          success={employeeData.joiningDateStatus === "success" ? true : false}
          //  success={true}
          disabled={togglePage.view === true ? true : false}
          inputProps={{
            max: new Date().toISOString().split("T")[0], // Today's date
            min: new Date(new Date().setMonth(new Date().getMonth() - 3))
              .toISOString()
              .split("T")[0], // 3 months before today
          }}
        /> */}
        {validationMessages.joiningDate && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.joiningDate}
          </label>
        )}
      </Grid>

      {console.log(reportManager, "repmanagerr")}

      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Reporting manager
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="reportingManager"
          customStyles={{ optionPadding: 20 }}
          value={employeeData.reportingManager}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={reportManager.map((value) => {
            return {
              value: value.user.firstName,
              label: value.user.firstName,
              id: value.user.id,
            };
          })}
          // options={reportManager.map((value) => {
          //   return {
          //     value: value.user.empid,
          //     label: value.user.username,
          //   };
          // })}
          error={
            employeeData.reportingManagerStatus === "error"
              ? true
              : false || validationMessages.reportingManager
          }
          isDisabled={togglePage.view === true ? true : false}
          success={
            employeeData.reportingManagerStatus === "success" ? true : false
          }
          isClearable
        />
        {validationMessages.reportingManager && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.reportingManager}
          </label>
        )}
      </Grid>
      {/* <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Employee type
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="employeeType"
          value={employeeData.employeeType}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={resources.employeeType.map((value) => {
            return {
              value: value.value,
              label: value.label,
            };
          })}
          error={employeeData.employeeTypeStatus === "error" ? true : false}
          success={employeeData.employeeTypeStatus === "success" ? true : false}
          isClearable
        />
      </Grid> */}
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Department <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="department"
          customStyles={{ optionPadding: 20 }}
          value={employeeData.department}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={department.map((value) => {
            return {
              value: value.departmentName,
              label: value.departmentName,
            };
          })}
          error={employeeData.departmentStatus === "error" ? true : false}
          success={employeeData.departmentStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.department && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.department}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Designation <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>

        <MaterialSelect
          inputId="designation"
          id="designation"
          name="designation"
          customStyles={{ optionPadding: 20 }}
          value={employeeData.designation}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={designation.map((value) => {
            return {
              value: value.designation,
              label: value.designation,
            };
          })}
          error={employeeData.designationStatus === "error" ? true : false}
          success={employeeData.designationStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />

        {validationMessages.designation && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.designation}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Employee Type <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>

        <MaterialSelect
          inputId="employeeType"
          id="employeeType"
          name="employeeType"
          customStyles={{ optionPadding: 20 }}
          value={employeeData.employeeType}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={typedata?.map((value) => {
            return {
              value: value.value,
              label: value.value,
            };
          })}
          error={employeeData.employeeTypeStatus === "error" ? true : false}
          success={employeeData.employeeTypeStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />

        {validationMessages.employeeType && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.employeeType}
          </label>
        )}
      </Grid>

      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Shifts <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="shifts"
          value={employeeData.shifts}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={shiftdata.map((value) => {
            return {
              value: value.name,
              label: value.name,
            };
          })}
          error={employeeData.shiftsStatus === "error" ? true : false}
          success={employeeData.shiftsStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.shifts && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.shifts}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Role <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialSelect
          name="role"
          value={employeeData.role}
          customStyles={{ optionPadding: 20 }}
          onChange={handleEmployeeDataChange} //selectedValue, event
          options={roledata?.map((value) => {
            return {
              roleid: value.id,
              value: value.role,
              label: value.role,
            };
          })}
          error={employeeData.roleStatus === "error" ? true : false}
          success={employeeData.roleStatus === "success" ? true : false}
          isDisabled={togglePage.view === true ? true : false}
          // isClearable
        />
        {validationMessages.role && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.role}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Official Mail ID <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <Stack>
          <MaterialInput
            name="officialmailid"
            value={employeeData.officialmailid}
            // placeholder="Enter a employee id"
            onChange={handleEmployeeDataChange}
            error={employeeData.officialmailidStatus === "error" ? true : false}
            success={
              employeeData.officialmailidStatus === "success" ? true : false
            }
            disabled={togglePage.view === true ? true : false}
          />
          {/* {employeeData.officialmailidStatus === "error" && (
            <FormControl error>
              <FormHelperText>
              Please enter a valid email address.
              </FormHelperText>
            </FormControl>
          )} */}
          {validationMessages.officialmailid && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.officialmailid}
            </label>
          )}
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Previous Experience (Years) <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="previousExperience"
          // placeholder="eg: 5.25"
          type="text" // Type as text to allow custom validation for 2 decimal places
          value={employeeData.previousExperience}
          // onChange={(e) => {
          //   const value = e.target.value;
          //   // Validate input to allow up to 2 digits and 2 decimals
          //   const isValid = /^\d{0,2}(\.\d{0,2})?$/.test(value);
          //   if (isValid) {
          //     handleEmployeeDataChange(e); // Pass valid input to handler
          //   }
          // }}
          onChange={handleEmployeeDataChange}
          error={employeeData.previousExperienceStatus === "error"}
          success={employeeData.previousExperienceStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.previousExperienceStatus === "error" && (
          <FormControl error>
            <FormHelperText>
              {employeeData.previousExperience
                ? "Invalid format. Please enter up to 2 digits and 2 decimal places."
                : "Previous Experience is Mandatory"}
            </FormHelperText>
          </FormControl>
        )}
        {validationMessages.previousExperience && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.previousExperience}
          </label>
        )}
      </Grid>
      <Grid size={{ xs: 12, sm: 4, lg: 4, md: 6 }}>
        <MaterialBox>
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Attendance ID
          </MaterialTypography>
        </MaterialBox>
        <MaterialInput
          name="attendanceId"
          value={employeeData.attendanceId}
          onChange={handleEmployeeDataChange}
          error={employeeData.attendanceIdStatus === "error"}
          success={employeeData.attendanceIdStatus === "success"}
          disabled={togglePage.view === true ? true : false}
        />
        {employeeData.attendanceIdStatus === "error" && (
          <FormControl error>
            <FormHelperText>Maximum characters allowed is 15</FormHelperText>
          </FormControl>
        )}
      </Grid>
      <Grid sx={{ marginLeft: "2%" }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Probation Period
          </MaterialTypography>
        </MaterialBox>
        <FormControlLabel
          sx={{ marginLeft: "1%" }}
          control={
            <Switch
              checked={employeeData.probationPeriod}
              name="probationPeriod"
              onChange={handleChange}
              color="primary"
            />
          }
          label={employeeData.probationPeriod ? "Yes" : "No"}
          disabled={
            employeeData.employeeType?.value == "Internship" ||
            togglePage.view === true
              ? true
              : false
          }
        />
        {employeeData.probationPeriodStatus === "error" && (
          <FormControl error>
            <FormHelperText>Probation Period is mandatory.</FormHelperText>
          </FormControl>
        )}
        {validationMessages.probationperiod && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.probationperiod}
          </label>
        )}
      </Grid>
      <Grid sx={{ marginLeft: "2%" }}>
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            OT Applicable
          </MaterialTypography>
        </MaterialBox>
        <FormControlLabel
          sx={{ marginLeft: "1%" }}
          control={
            <Switch
              checked={employeeData.user}
              name="user"
              onChange={handleChange}
              color="primary"
            />
          }
          label={employeeData?.user ? "Yes" : "No"}
          disabled={
            employeeData?.employeeType?.value === "Internship" ||
            togglePage.view === true
              ? true
              : false
          }
        />
        {validationMessages.user && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.user}
          </label>
        )}
      </Grid>

      {/* <Grid sx={{marginLeft:'2%'}} >
        <MaterialBox lineHeight={0} display="inline-block">
          <MaterialTypography
            component="label"
            variant="caption"
            fontWeight="bold"
          >
            Is Active
          </MaterialTypography>
        </MaterialBox>
        <FormControlLabel
          sx={{ marginLeft: "1%" }}
          control={
            <Switch
              checked={employeeData.isActive}
              name="isActive"
              onChange={handleChange}
              color="primary"
            />
          }
          label={employeeData?.isActive ? "Yes" : "No"}
          disabled={ togglePage.view === true ? true : false}
        />
        {validationMessages.user && (
          <label style={{ color: "red", fontSize: "12px" }}>
            {validationMessages.user}
          </label>
        )}
      </Grid> */}

      {console.log(togglePage, "23dsa")}
      {(togglePage.view || togglePage.edit) && (
        <Grid size={{ xs: 12, sm: 8, lg: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Active User
            </MaterialTypography>
          </MaterialBox>
          <FormControlLabel
            sx={{ marginLeft: "1%" }}
            control={
              <Switch
                checked={employeeData.activeuser}
                name="activeuser"
                onChange={handleactive}
                color="primary"
              />
            }
            label={employeeData?.activeuser ? "Yes" : "No"}
            disabled={togglePage.view === true ? true : false}
          />
          {validationMessages.user && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.user}
            </label>
          )}
        </Grid>
      )}
      {(togglePage.view || togglePage.edit) && !employeeData.activeuser && (
        <Grid size={{ xs: 12, sm: 4, lg: 4 }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Last Working Day
            </MaterialTypography>
          </MaterialBox>
          <MaterialInput
            name="lastworking"
            type="date"
            value={employeeData.lastworking}
            onChange={handleEmployeeDataChange}
            error={employeeData.lastworkingStatus === "error" ? true : false}
            success={
              employeeData.lastworkingStatus === "success" ? true : false
            }
            // disabled={togglePage.view === true ? true : false}
            inputProps={{
              min: employeeData.joiningDate,
            }}
          />

          {validationMessages.joiningDate && (
            <label style={{ color: "red", fontSize: "12px" }}>
              {validationMessages.joiningDate}
            </label>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default EmployeeInformation;
